import validator from "validator";

const defaultLoginState = {
  showEmailHint: false,
  showPasswordHint: false,
  email: {
    value: '',
    isDirty: false,
    isValid: false,
  },
  password: {
    value: '',
    isText: true,
    isDirty: false,
    isValid: false,
  },
  stayLoggedIn: false
};

const loginAction = {
  toggleEmailHint: 'TOGGLE_EMAIL_HINT',
  togglePasswordHint: 'TOGGLE_PASSWORD_HINT',
  changeEmail: 'CHANAGE_EMAIL',
  changePassword: 'CHANGE_PASSWORD',
  toggleEye: 'TOGGLE_EYE',
  clickStayLoggedIn: 'CLICK_STAY_LOGGEDIN'
}

const loginReducer = (state, action) => {
  switch (action.type) {
    case loginAction.toggleEmailHint:
      return {
        ...state,
        showEmailHint: action.payload
      };
    case loginAction.togglePasswordHint:
      return {
        ...state,
        showPasswordHint: action.payload
      };
    case loginAction.changeEmail:
      return {
        ...state,
        email: {
          value: action.payload,
          isDirty: true,
          isValid: validator.isEmail(action.payload)
        }
      };
    case loginAction.changePassword:
      return {
        ...state,
        password: {
          ...state.password,
          value: action.payload,
          isDirty: true,
          isValid: validator.isByteLength(action.payload, { min: 8, max: 64 })
        }
      };
    case loginAction.toggleEye:
      return {
        ...state,
        password: {
          ...state.password,
          isText: !state.password.isText
        }
      };
    case loginAction.clickStayLoggedIn:
      return {
        ...state,
        stayLoggedIn: !state.stayLoggedIn
      };
    default:
      return defaultLoginState;
  }
};

export default {
  defaultState: defaultLoginState,
  action: loginAction,
  reducer: loginReducer
}